<h2 mat-dialog-title class="text-lg font-bold mb-1">Agregar Clientes</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="form">
    <app-configuration-filters [form]="form" [distributionChainWithMongoId]="true"></app-configuration-filters>

    <div class="flex flex-row items-center gap-4 mb-4">
      <mat-label class="mb-2">Asignar a:</mat-label>
      <mat-radio-group aria-label="Seleccionar clientes" formControlName="customerSelectionType"
        class="flex flex-row gap-4">
        <mat-radio-button [value]="'all'">Todos los clientes</mat-radio-button>
        <mat-radio-button [value]="'specific'">Clientes en específico</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="form.get('customerSelectionType')?.value === 'specific'">

      <div class="flex flex-row items-center gap-4 mb-4">
        <mat-label class="mb-2">Seleccionar por:</mat-label>
        <mat-radio-group aria-label="Seleccionar clientes" formControlName="customersSelectedsBy"
          class="flex flex-row gap-4">
          <mat-radio-button [value]="'customers'">Clientes</mat-radio-button>
          <mat-radio-button [value]="'businessPartnerGroup'">Grupo de socios de negocios</mat-radio-button>
        </mat-radio-group>
      </div>

      <div *ngIf="form.get('customersSelectedsBy')?.value === 'customers'">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Buscar y agregar cliente</mat-label>
          <mat-select [formControl]="customerSelectControl" multiple>

            <mat-select-trigger>
              <span *ngIf="dataSource.data?.length > 0">
                {{ dataSource.data?.length }} cliente(s) seleccionado(s)
              </span>
            </mat-select-trigger>

            <mat-option>
              <ngx-mat-select-search [formControl]="customerSearchControl" placeholderLabel="Buscar cliente..."
                noEntriesFoundLabel="No se encontraron resultados" [clearSearchButton]="true">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let customer of filteredCustomers" [value]="customer">
              <div *ngIf="customer.externalKeys">
                <div *ngIf="getCode(customer) as code">
                  <b class="f-10">{{ code }}</b>
                </div>
              </div>
              {{ customer?.name }} - {{customer.businessPartnerGroup?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div
          class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
          <!-- Main Content (Table and Paginator) -->
          <div class="pt-1 mx-6">
            <!-- Tabla -->
            <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
              <!-- Header -->
              <div class="overflow-auto flex-1 dark:bg-gray-900">
                 <table class="w-full bg-transparent" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'BUSINESS_PARTNER.NAME' | transloco }}
            </th>
            <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
              <div *ngIf="businessPartner.externalKeys">
                <div *ngIf="getCode(businessPartner) as code">
                  <b class="f-10">{{ code }}</b>
                </div>
              </div>
              {{ businessPartner.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="partnerGroup">
            <th mat-header-cell *matHeaderCellDef>
              {{'BUSINESS_PARTNER.GROUP' | transloco }}
            </th>
            <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase">
              {{ businessPartner.businessPartnerGroup?.name || "No asignada" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let customer">
              <button mat-icon-button color="warn" (click)="removeSelectedCustomer(customer._id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b h-16"></tr>
        </table>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="form.get('customersSelectedsBy')?.value === 'businessPartnerGroup'">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Grupo de Socio de negocios</mat-label>
          <mat-select formControlName="businessPartnerGroupId" placeholder="Seleccione un grupo" multiple>

            <mat-select-trigger>
              {{getDisplayValueForMongoId(businessGroupList, form.get('businessPartnerGroupId')?.value, 'name')}}
            </mat-select-trigger>

            <mat-option>
              <ngx-mat-select-search formControlName="searchBusinessPartenertGroup"
                placeholderLabel="Buscar grupo de Socio de negocios..."
                noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let businessGroup of filteredBusinessGroupList"
              [value]="businessGroupWithMongoId ? businessGroup._id : businessGroup._id">
              {{ businessGroup.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>


    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="addCustomers()" [disabled]="form.invalid">
    Guardar
  </button>
</mat-dialog-actions>